import LayoutActividad from "../../../components/LayoutActividad";
import Kashiri from "../../../images/modulo14/kashiri.png";
import Selvaverde from "../../../images/modulo14/selvaverde.png";

import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";

const Actividad4 = () => {
  const infoUnidad = modulo14.content[0];
  const infoAct = modulo14.content[0].activities[5];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[0].name}: ${modulo14.content[0].activities[6].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[6].path}`,
    titlePrev: `${modulo14.content[0].name}: ${modulo14.content[0].activities[4].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[4].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>
      <div className="bg-light p-3 mt-5 rounded">
        <div className="row align-items-center">
          <div className="col-md-8 col-12 p-md-3 p-0">
            <h4 className="mb-4">
              <strong>Lenguas vivas</strong>
            </h4>
            <p className="mt-1">
              De todas las lenguas habladas en el Perú, la mayoría se encuentra
              en la selva. Algunas de ellas también se hablan en Brasil, Bolivia
              y Colombia. Las lenguas{" "}
              <strong>se mueven con sus hablantes</strong>. Un ejemplo de ello
              es el asháninka, que se habla en el Perú y también en Brasil.
            </p>
          </div>
          <div className="col-md-4 col-12">
            <img
              src={Kashiri}
              className="bg-white img-fluid rounded w-100"
              alt="dialogo"
            />
          </div>
          <div className="col-md-3 col-12">
            <img
              src={Selvaverde}
              className="bg-white img-fluid rounded w-100"
              alt="dialogo"
            />
          </div>
          <div className="col-md-9 col-12 p-md-3 p-0">
            <p>
              Las lenguas <strong>expresan la realidad</strong> en la que viven
              sus hablantes. Así, en las lenguas de la selva, por ejemplo,
              encontraremos muchas palabras para referirse a distintos tonos del
              color verde.
            </p>
            <p>
              Las lenguas se mantienen vivas gracias a que hay personas que las
              hablan y que las van <strong>transformando</strong>{" "}
              constantemente.
            </p>
          </div>
        </div>
      </div>
      <GuiaDocente>
        <ul>
          <li>
            Pida que lean el título del texto, Lenguas vivas, y que observen las
            imágenes que ofrece la ilustración. Pregunte lo siguiente:
            <ul>
              <li>
                <i>
                  “¿De qué se trata la primera imagen? (Posible respuesta: En la
                  imagen vemos a dos personas que hablan la misma lengua pero
                  que pertenecen a dos países distintos: Perú y Brasil).
                  (“Kashiri” significa “luna” en ashaninka).
                </i>
              </li>
              <li>
                <i>
                  ¿Qué vemos en la segunda imagen? (Posible respuesta: Parece un
                  lugar de la selva. Se observa mucha vegetación).
                </i>
              </li>
            </ul>
          </li>

          <li>
            Ahora pida que lean en voz alta la información que ofrece el texto.
            Para finalizar la sesión, pregunte de qué depende la existencia o la
            vigencia de una lengua. También puede preguntar por qué es
            importante mantener la diversidad de lenguas. Retome las ideas
            presentadas en el texto y resalte la importancia del uso de las
            leguas para su existencia. Asimismo, señale que las lenguas son
            importantes para la comunicación y para acceder a ciertos
            conocimientos característicos de determinadas poblaciones.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
